var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errorMessage
      ? _c("div", { staticClass: "notification is-danger is-light" }, [
          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
        ])
      : _vm._e(),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _vm._m(0),
        _c(
          "required-field",
          {
            attrs: {
              error: _vm.$v.password.$error,
              required: _vm.$v.password.required,
              label: "Password",
            },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.$v.password.$model,
                  expression: "$v.password.$model",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.$v.password.$error },
              attrs: { type: "password" },
              domProps: { value: _vm.$v.password.$model },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.$v.password,
                    "$model",
                    $event.target.value.trim()
                  )
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            !_vm.$v.password.minLength
              ? _c("p", { staticClass: "help is-danger" }, [
                  _vm._v(
                    " Password must have at least " +
                      _vm._s(_vm.$v.password.$params.minLength.min) +
                      " "
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "buttons mt-6" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary is-fullwidth",
              class: [{ "is-loading": _vm.fetching }],
              attrs: { disabled: !_vm.isValid },
            },
            [_vm._v(" Save ")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("Please enter your new password.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }